/**
 * 文件上传 API（对接 tRPC 后端 trpc.samples.deeptutor.Admin）
 */
import { http } from '@/utils';

const Api = {
    Upload: '/UploadFile',
};

/**
 * 上传文件到 OSS，返回公开 URL。
 * Content 为 base64 编码的文件内容（不含 data: 前缀）。
 */
export async function uploadFile(params: API.UploadFileReq): Promise<string> {
    const response = await http.post<API.UploadFileRsp>(Api.Upload, params);
    return response?.Data?.Url || '';
}
